<style>
.overflowing-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 1px;
}
.mr-2 {
  margin-right: 2em;
}
</style>

<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fas fa-ticket"></i> Munkafolyamatok
        </h1>
      </div>
    </div>
    <panel
      title="Munkafolyamatok"
      @reloadingpanel="reloadTasks"
      ref="taskTablePanel"
    >
      <Loading
        v-if="tasks === false"
        title="Munkafolyamatok betöltése"
      ></Loading>
      <NoRecords
        v-if="tasks.length == 0"
        main_icon="fa fa-ticket"
        value="false"
        title="Nincsenek munkafolyamatok"
        subtitle="hozzon létre újat"
      ></NoRecords>
      <div v-if="tasks.length != 0 && tasks != false">
        <div v-if="computed_task_status_array" class="mb-3">
          <label class="form-label me-2">Látható státuszok: </label>
          <div class="form-check form-check-inline form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="serverParams.all_statuses"
              @change="allSelsectHandler"
              :true-value="true"
              :false-value="false"
            />
            <span class="badge bg-default text-inverse">ÖSSZES</span>
          </div>
          <div
            v-for="(option, id) in computed_task_status_array"
            :key="id"
            class="form-check form-check-inline form-switch"
          >
            <input
              class="form-check-input"
              type="checkbox"
              v-model="serverParams.selected_statuses"
              :value="option"
              @change="loadItemsOnStatusChange()"
            />
            <label class="form-check-label">
              <span
                class="badge bg-default text-inverse"
                :class="{
                  'bg-indigo text-white': option.value == 50,
                  'bg-green text-white': option.value == 70,
                }"
              >
                <i
                  v-if="[50, 70].includes(option.value)"
                  class="fa"
                  :class="{
                    'fa-forward': option.value == 50,
                    'fa-check-circle': option.value == 70,
                  }"
                >
                </i>
                {{ option.text }}
              </span>
            </label>
          </div>
        </div>
        <vue-good-table
          :columns="columns"
          :rows="tasks.data"
          :lineNumbers="false"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          :totalRows="tasks.total"
          :isLoading.sync="loading"
          :search-options="{ enabled: false, placeholder: 'Keresés...' }"
          :pagination-options="paginationOptions"
        >
          <template slot="column-filter" slot-scope="{ column, updateFilters }">
            <v-select
              v-if="
                column.filterOptions &&
                column.filterOptions.customFilter &&
                computed_task_status_array.length != 0
              "
              class="bg-white"
              style="width: 180px"
              placeholder="Összes státusz"
              :options="computed_task_status_array"
              label="text"
              multiple
              @input="(valuesArray) => updateFilters(column, valuesArray)"
              :value="serverParams.selected_statuses"
            >
              <template #selected-option-container="{ option }">
                <span
                  class="pt-2"
                  :ref="'vgt_option_' + option.value"
                  style="width: 100px; overflow: hidden"
                  v-if="serverParams.selected_statuses[0].value == option.value"
                  >{{ serverParams.selected_statuses.length }} kiválasztva</span
                >
                <span class="d-none" v-else></span>
              </template>
            </v-select>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'actions'">
              <router-link
                :to="'/tasks/' + props.row.id + '/edit'"
                class="btn btn-primary mx-1"
                title="szerkesztés"
                ><i class="fa fa-pen"></i
              ></router-link>
              <button
                v-if="user && user.role_id == 5 && props.row.status == 70"
                class="btn btn-warning mx-1"
                title="másolás"
                @click="showTaskCopyDialogue(props.row.id)"
              >
                <i class="fa fa-copy"></i>
              </button>
              <button
                v-if="
                  (props.row.status == 20 &&
                    props.row.needs_crane == 1 &&
                    user &&
                    [1, 5].includes(user.role_id)) ||
                  (props.row.status <= 15 &&
                    user &&
                    ([1, 5].includes(user.role_id) ||
                      (user.id == props.row.location_leader_id &&
                        user.role_id == 3)))
                "
                @click="deleteTask(props.row.id)"
                class="btn btn-danger mx-1"
                title="törlés"
              >
                <i class="fa fa-trash"></i>
              </button>
            </span>
            <span v-else-if="props.column.field == 'security_type'">
              <span v-if="security_types">
                <i
                  class="fa fa-unlock text-blue mr-2"
                  v-if="props.row.security_type != 1"
                  title="van lakatolás"
                ></i>
                <i
                  class="fa fa-bolt text-orange"
                  v-if="props.row.security_type == 4"
                  title="0,4 kV feszültségmentesítés"
                ></i>
                <i
                  class="fa fa-charging-station text-red"
                  v-else-if="props.row.security_type == 3"
                  title="6,3 kV feszültségmentesítés"
                ></i>
              </span>
              <Loading v-else mini></Loading>
            </span>
            <span v-else-if="props.column.field == 'status'">
              <span v-if="task_statuses">
                <a
                  v-if="props.row.fnprobe != null"
                  v-b-modal.fnprobe_details_modal
                  @click="getFnProbeDetails(props.row.id)"
                  title="Funkciópróba adatai"
                >
                  <i
                    v-if="
                      JSON.parse(props.row.fnprobe).fn_probe_checked.length ==
                        1 &&
                      JSON.parse(props.row.fnprobe).fn_probe_checked[0] == 100
                    "
                    class="fa fa-times-circle text-green mr-1"
                  ></i>
                  <i v-else class="fa fa-check-circle text-green mr-1"></i>
                </a>

                <span
                  :class="{
                    'badge bg-indigo': props.row.status == 50,
                    'badge bg-green': props.row.status == 70,
                  }"
                >
                  <i
                    v-if="[50, 70].includes(props.row.status)"
                    class="fa"
                    :class="{
                      'fa-forward': props.row.status == 50,
                      'fa-check-circle': props.row.status == 70,
                    }"
                  >
                  </i>
                  {{
                    task_statuses[
                      task_statuses.map((s) => s.id).indexOf(props.row.status)
                    ].name
                  }}
                </span>
              </span>
              <Loading v-else mini></Loading>
            </span>
            <span v-else-if="props.column.field == 'permits'">
              {{ props.row.permits }}
              <div v-if="props.row.permits">
                <div
                  v-for="(permit, id) in JSON.parse(props.row.permits)"
                  :key="id"
                >
                  <span
                    v-if="
                      permit_types
                        .map((permit_type) => permit_type.id)
                        .indexOf(parseInt(permit)) != -1
                    "
                  >
                    {{
                      permit_types[
                        permit_types
                          .map((pertmit_type) => pertmit_type.id)
                          .indexOf(parseInt(permit))
                      ].name
                    }}
                  </span>
                  <span v-else-if="id == 0">Nincsenek engedélyek</span>
                </div>
              </div>
            </span>
            <span v-else-if="props.column.field == 'created_at'">
              {{ props.row.created_at | moment("YYYY-MM-DD, HH:mm") }}
            </span>
            <span v-else-if="props.column.field == 'crane'">
              <span v-if="props.row.crane == 0">nincs</span>
              <span v-else-if="props.row.crane == 1">
                <i class="fa fa-arrow-down-up-across-line text-red"></i>
              </span>
              <span v-else-if="props.row.crane == 2">
                <i class="fa fa-arrow-down-up-across-line text-green"></i>
              </span>
            </span>
            <span v-else-if="props.column.field == 'name'">
              {{ props.formattedRow[props.column.field] }}
              <span
                class="badge bg-danger rounded-pill"
                title="ideiglenesen feszültség alá helyezve"
                v-if="props.row.has_active_temporary_reconnect"
                ><i class="fa-solid fa-plug fa-fade"></i
              ></span>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <b-modal
          size="lg"
          id="fnprobe_details_modal"
          hide-footer
          @hide="resetFnProbeDetails"
        >
          <template slot="modal-header">
            <h4 class="modal-title">Funkciópróba részletei</h4>
            <a
              class="btn-close"
              @click="$bvModal.hide('fnprobe_details_modal')"
            ></a>
          </template>
          <b-container>
            <Loading
              v-if="!fnProbeDetails"
              title="Funkciópróba adatainak betöltése"
            ></Loading>
            <div v-else>
              <table class="table table-striped">
                <tbody>
                  <tr v-if="fnProbeDetails.message_created_by">
                    <td>Funkciópróbát elvégezte</td>
                    <td>{{ fnProbeDetails.message_created_by }}</td>
                  </tr>
                  <tr v-if="fnProbeDetails.created_at">
                    <td>Időpont</td>
                    <td>
                      {{
                        fnProbeDetails.created_at | moment("YYYY-MM-DD HH:mm")
                      }}
                    </td>
                  </tr>
                  <tr v-if="fnProbeDetails.message_recipient">
                    <td>Üzenet címzettje</td>
                    <td>{{ fnProbeDetails.message_recipient }}</td>
                  </tr>
                  <tr v-if="fnProbeDetails.message_text">
                    <td>Üzenet</td>
                    <td>{{ fnProbeDetails.message_text }}</td>
                  </tr>
                  <tr>
                    <td valign="top">Elvégzett próbák</td>
                    <td>
                      <div v-if="fnProbeDetails.fn_probe_checked.length > 0">
                        <div
                          v-for="(
                            detail_id, key
                          ) in fnProbeDetails.fn_probe_checked"
                          :key="key"
                        >
                          {{
                            fn_probe_options[
                              fn_probe_options
                                .map((s) => s.id)
                                .indexOf(detail_id)
                            ].name
                          }}
                        </div>
                      </div>
                      <div v-else>Nem lett végezve próba</div>
                    </td>
                  </tr>
                  <tr v-if="fnProbeDetails.fn_probe_disabled.length > 0">
                    <td valign="top">Nem alkalmazható próbák</td>
                    <td>
                      <div
                        v-for="(
                          detail_id, key
                        ) in fnProbeDetails.fn_probe_disabled"
                        :key="key"
                      >
                        {{
                          fn_probe_options[
                            fn_probe_options.map((s) => s.id).indexOf(detail_id)
                          ].name
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-container>
        </b-modal>
      </div>
    </panel>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Task from "../../apis/Task";
//import User from "../../apis/User";
import Workflow from "../../apis/Workflow";
import Confirmation from "../../apis/Confirmation";
import Config from "@/apis/Config";
import moment from "moment";

export default {
  components: {
    Loading,
    NoRecords,
  },
  data() {
    return {
      now: moment().format("YYYY-MM-DD"),
      paginationOptions: {
        perPage: 10,
        enabled: true,
        position: "bottom",
        firstLabel: "Első Lap",
        lastLabel: "Utolsó Lap",
        nextLabel: "következő",
        prevLabel: "előző",
        rowsPerPageLabel: "Sor oldalanként",
        ofLabel: "/",
        allLabel: "Összes",
        dropdownAllowAll: false,
        infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
      },
      columns: [
        {
          label: "#",
          field: "id",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés az azonosítók között",
          },
          tdClass: "fw-bold text-center",
          thClass: "fw-bold text-center",
        },
        {
          label: "Megnevezés",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
          width: "25%",
        },
        {
          label: "Létrehozva",
          field: "created_at",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Emelőgép",
          field: "crane",
          filterOptions: {
            enabled: true,
            placeholder: "Összes emelőgép státusz",
            filterDropdownItems: [
              { value: 0, text: "nincs" },
              { value: 1, text: "folyamatban" },
              { value: 2, text: "visszahozva" },
            ],
          },
          tdClass: "fw-bold text-center",
          width: "5%",
        },
        {
          label: "Lakatolás",
          field: "security_type",
          filterOptions: {
            filterDropdownItems: [
              /*
								nincs semmi -> nincs lakatolás
								van lakat és nincs fm -> lakatolás
								van lakat és 0.4 -> lakatolás és feszmentesítés
								6.3 -> 6.3 feszmentesítés
								*/
              { value: 1, text: "nincs lakatolás" },
              { value: 2, text: "lakatolás" },
              { value: 4, text: "lakatolás és 0,4 kV feszültségmentesítés" },
              { value: 3, text: "6,3 kV feszültségmentesítés" },
            ],
            placeholder: "Összes lakatolás",
            enabled: true,
          },
          tdClass: "text-center",
        },
        {
          label: "Státusz",
          field: "status",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Kapcsolódó",
          field: "related_task_ids",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Pozíciók",
          field: "positions",
          //width: '70px',
          filterOptions: {
            enabled: true,
            placeholder: "Keresés",
          },
        },
        {
          label: "Projektvezető",
          field: "owner",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a projektvezetők között",
          },
        },
        {
          label: "Területvezető",
          field: "location_leader",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a területvezetők között",
          },
        },
        {
          label: "Kék lakat felvevő",
          field: "ddc_user",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a kék lakatot felvevők között",
          },
        },
        /*{
						label: 'Engedélyek',
						field: row => this.taskPermitField(row),
						filterOptions : {
							placeholder: 'engedélyek',
							enabled:true,
						}
					},*/
        {
          label: "Műveletek",
          field: "actions",
          width: "10%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end buttons-wide-3",
        },
      ],
      tasks: false,
      errors: [],
      loading: false,
      electricians: false,
      electricians_6_3_kv: false,
      partners: false,
      outside_job: false,
      permit_types: false,
      security_types: false,
      boxes: false,
      free_locks: false,
      position_v_select_search_input_is_focusedok: false,
      task_statuses: false,
      serverParams: {
        selected_statuses: [],
        all_statuses: true,
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        perPage: 10,
      },
      fnProbeDetails: false,
      fn_probe_options: [],
      task: null,
      temporaryTaskForCopying: null,
    };
  },
  computed: {
    computed_task_status_array() {
      if (this.task_statuses) {
        return this.task_statuses.map((s) => ({ value: s.id, text: s.name }));
      } else {
        return [];
      }
    },
    partners_with_ddc() {
      let existing_partners = JSON.parse(JSON.stringify(this.partners));
      if (!existing_partners) {
        existing_partners = [];
      }
      existing_partners.push({ id: "ddc", name: "DDC" });
      return existing_partners;
    },
    project_leaders() {
      if (this.users) {
        return this.users.filter((u) => u.role_id == 5);
      } else {
        return [];
      }
    },
    workers() {
      if (this.users) {
        return this.users.filter((u) => u.role_id == 10);
      } else {
        return [];
      }
    },
    location_leads() {
      if (this.users) {
        return this.users.filter((u) => [3, 4, 5].includes(u.role_id));
      } else {
        return [];
      }
    },
    security_types_array: function () {
      if (this.security_types === false) {
        return [];
      } else {
        return Object.values(this.security_types);
      }
    },
    user() {
      return this.$store.state.user;
    },
    task_table_state() {
      return this.$store.state.task_table_state;
    },
    filtered_permit_types() {
      if (this.outside_job) {
        return this.permit_types.filter((p) => p.id != 5);
      } else {
        return this.permit_types.filter((p) => ![3, 5].includes(p.id));
      }
    },
    users_available_for_permit() {
      //mindig benne kell lenni most a partnereknek de kesobb ha valtozna megtartottam a szűrést is
      return this.users;
      /*if(this.outside_job){
					return this.users.filter(u => !u.partner_id || u.partner_id == this.task.partner_id );
				}else{
					return this.users.filter(p => ![6,11].includes(p.role_id) );
				}*/
    },
  },
  created() {
    Task.indexWithParams(this.serverParams).then((response) => {
      this.tasks = response.data;
    });
    Workflow.index().then((response) => {
      this.workflows = response.data;
    });

    this.permit_types = JSON.parse(
      localStorage.getItem("constants"),
    ).permit_types;
    this.security_types = JSON.parse(
      localStorage.getItem("constants"),
    ).security_types;
    this.task_statuses = JSON.parse(
      localStorage.getItem("constants"),
    ).task_status;
    this.permit_local_roles = JSON.parse(
      localStorage.getItem("constants"),
    ).permit_local_roles;
    window.Echo.channel("tasks").listen("TaskDeleted", (e) => {
      console.log(this.tasks.data);
      this.tasks.data.splice(
        this.tasks.data.findIndex((t) => t.id == e.id),
        1,
      );
    });

    Config.getConstant("fn_probe_options").then((response) => {
      this.fn_probe_options = JSON.parse(JSON.stringify(response.data));
    });
  },
  mounted() {
    if (this.task_table_state) {
      this.serverParams = this.task_table_state.serverParams;
      this.columns = this.task_table_state.columns;
      Object.keys(this.serverParams.columnFilters).forEach((key) => {
        this.columns.find((c) => c.field == key).filterOptions.filterValue =
          this.serverParams.columnFilters[key];
      });

      this.loadItems();
    }
  },
  watch: {
    computed_task_status_array: function (val, prev) {
      console.log("computed_task_status_array changed", val, prev);
      if (prev.length == 0 && !this.task_table_state) {
        this.serverParams.selected_statuses = val.filter((s) => s.value != 70);
      }
    },
    task_table_state: {
      handler(val, oldVal) {
        if (!oldVal && val) {
          this.serverParams = this.task_table_state.serverParams;
          this.columns = this.task_table_state.columns;
          Object.keys(this.serverParams.columnFilters).forEach((key) => {
            this.columns.find((c) => c.field == key).filterOptions.filterValue =
              this.serverParams.columnFilters[key];
          });

          this.loadItems();
        }
      },
      deep: true,
    },
    "serverParams.selected_statuses": {
      handler(val, oldVal) {
        if (oldVal && val.length != oldVal.length) {
          this.$store.commit("updateTaskTableState", {
            serverParams: this.serverParams,
            columns: this.columns,
          });
        }
        if (val.length == this.task_statuses.length) {
          this.serverParams.all_statuses = true;
        } else {
          this.serverParams.all_statuses = false;
        }
      },
      deep: true,
    },
    columns: {
      handler(val, oldVal) {
        if (oldVal && val != oldVal) {
          this.$store.commit("updateTaskTableState", {
            serverParams: this.serverParams,
            columns: this.columns,
          });
        }
      },
      deep: true,
    },
    "serverParams.all_statuses": function (val, oldVal) {
      if (oldVal && val != oldVal) {
        this.$store.commit("updateTaskTableState", {
          serverParams: this.serverParams,
          columns: this.columns,
        });
      }
    },
    "serverParams.columnFilters": function (val, oldVal) {
      if (oldVal && val != oldVal) {
        this.$store.commit("updateTaskTableState", {
          serverParams: this.serverParams,
          columns: this.columns,
        });
      }
    },
    wizard_step: function (val) {
      if (val == 4 && this.outside_job) {
        /*this.task.permits.push("4");
					document.getElementById('perimt_checkbox_input3').checked = true;*/
      }
    },
    outside_job: function (value) {
      if (!value && !this.task.id) {
        this.$set(this.task, "partner_id", undefined);
        this.$set(this.task, "permits", []);
        this.$set(this, "coordination", 1);
        this.$delete(this.task, "partner_user_id");
        /*document.getElementsByClassName("permit_checkbox").forEach(pcb => {
						pcb.checked = false;
					});*/
      }
    },
    coordination() {
      this.$delete(this.task, "coordination_partner_id");
      this.$delete(this.task, "coordination_user_id");
    },
    unique_workflow: function () {
      this.task.workflow_id = null;
    },
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.serverParams.page = 1;
      this.serverParams.currentPage = 1;
      this.loadItems();
    },
    setLoading(value) {
      this.loading = value;
    },
    loadItemsOnStatusChange() {
      this.resetPagination();
      this.loadItems();
    },
    loadItems() {
      this.setLoading(true);
      Task.indexWithParams(this.serverParams)
        .then((response) => {
          this.tasks = response.data;
          this.updateParams({
            currentPage: response.data.current_page,
            page: response.data.current_page,
            perPage: response.data.per_page,
          });
        })
        .finally(() => {
          this.setLoading(false);
        });
    },
    allSelsectHandler() {
      this.resetPagination();

      if (this.serverParams.all_statuses) {
        this.serverParams.selected_statuses = this.task_statuses.map((s) => ({
          value: s.id,
          text: s.name,
        }));
      } else {
        this.serverParams.selected_statuses = [];
      }
      this.loadItems();
      this.$forceUpdate(this.tasks);
    },
    resetPagination() {
      this.serverParams.page = 1;
      this.serverParams.currentPage = 1;
      this.paginationOptions = Object.assign({}, this.paginationOptions, {
        setCurrentPage: 1,
      });
    },
    copyTask(options) {
      let copyMode = options.fullCopy ? "full" : "basic";
      Task.loadForCopying(options.taskToCopy, copyMode).then((response) => {
        this.$root.$emit("task-load", response.data);
      });
    },
    showTaskCopyDialogue(task_id) {
      this.$swal({
        icon: "warning",
        title: "Válasszon másolási módot!",
        text: "Alap módban lemásolja a feladat nevét,kiegészítő információit, lakatolási módját és hajtásait de a munkavégzőket és engedélyeiket meg kell határoznia",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Munkafolyamat",
        denyButtonText: `Munkafolyamat engedélyekkel`,
        denyButtonColor: "orange",
        confirmButtonColor: "green",
        iconColor: "green",
        cancelButtonText: `Mégse`,
      }).then((result) => {
        if (!result.isDismissed) {
          /*
						3 gomb van alap: isConfirmed munkavégzőkkel: isDenied mégsem: isDismissed. 
						az alap másolásnál az isConfirmed true, a teljes másolásnál az isDenied
						furán hathat, de ez rendben van így
						*/
          this.copyTask({ taskToCopy: task_id, fullCopy: result.isDenied });
        }
      });
    },
    reloadTasks() {
      Task.indexWithParams(this.serverParams).then((response) => {
        this.tasks = response.data;
        this.$refs.taskTablePanel.resetReload();
      });
    },
    taskPermitField(rowObj) {
      if (rowObj.task_permit_types.length == 0) {
        return "nincsenek engedélyek";
      } else {
        return rowObj.task_permit_types
          .map(
            (t) =>
              this.permit_types[
                this.permit_types.map((pt) => pt.id).indexOf(t.permit_type)
              ].name,
          )
          .join();
      }
    },
    deleteTask(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Task.delete(id).catch((error) => {
            console.log(error);
          });
        }
      });
    },
    getFnProbeDetails(task_id) {
      Task.fnProbeDetails(task_id).then((response) => {
        this.fnProbeDetails = response.data;
      });
    },
    resetFnProbeDetails() {
      this.fnProbeDetails = false;
    },
  },
};
</script>

<style></style>
